<template>
    <!-- 新闻资讯 -->
  <section>
    <div class="news w-1200" v-if="type===1">
      <ul>
        <li v-for="(item,i) in articleItems" :key="i">
          <img :src="item.imgSrc" alt="">
          <div class="news-title">{{item.title}}</div>
          <div class="describe animate__animated animate__fadeInUp">
            <div v-html="item.content"></div>
              <div class="mt30">
                <span class="btn" @click="$router.push({path:'/Article',query:{id:i}})">查看详情</span>
              </div>
          </div>
        </li>
      </ul>
      <div class="more"><span class="btn" @click="$router.push('/newsList')">查看更多</span></div>
    </div>
    <div v-if="type===2" class="news2">
          <el-carousel trigger="click" height="300px" indicator-position="outside" arrow="always" :autoplay="false">
            <el-carousel-item v-for="(item,i) in articleList" :key="i">
                <div class="content_box">
                  <div class="name">{{item.title}}</div>
                  <div class="desc" v-html="item.content"></div>
                  <a class="detail" @click="$router.push({path:'/Article',query:{id:i}})">查看详情</a>
                </div>
                <div class="img_box">
                  <img :src="item.imgSrc" alt="">
                </div>
            </el-carousel-item>
          </el-carousel>
      </div>
  </section>
</template>

<script>
import articleJson from '@/http/data/news.json'
export default {
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  computed: {
    articleItems: function () {
      return this.articleList.slice(0, 3)
    }
  },
  data () {
    return {
      articleList: []
    }
  },
  created () {
    this.articleList = JSON.parse(JSON.stringify(articleJson.data))
    this.articleList.forEach(item => {
      item.content = item.content.substr(0, 120) + '...'
    })
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "~@/styles/variable.scss";
.news{
      position: relative;
      overflow: hidden;
      margin: 0 auto;
      padding-bottom: 60px;
      ul{
        overflow: hidden;
        li{
          width: calc((100% - 60px)/3);
          float: left;
          height: 232px;
          text-align: center;
          margin-right: 20px;
          position: relative;
          img{
            width: 100%;
          }
          &:hover{
            .news-title{
              display: none;
            }
            .describe{
              display: inline-block;
            }
          }
          .news-title{
            position: absolute;
            left: 0;
            color: #fff;
            padding: 0 20px;
            text-align: left;
            display: inline-block;
            height: 65px;
            width: 100%;
            bottom: 0;
            background: rgba(0,0,0,.7);
            padding-top: 10px;
            font-size: 16px;
          }
          .describe{
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.7);
            width: 100%;
            height: 100%;
            color:#fff;
            padding: 20px;
            text-align: left;
            box-sizing: border-box;
            padding-top: 30px;
            font-size: 14px;
            line-height: 22px;
            .btn{
              display: inline-block;
              padding: 5px 12px;
              border: 1px solid #fff;
              cursor: pointer;
              font-size: 12px;
            }
          }
        }
      }
      .more{
        text-align: center;
        margin-top: 40px;
        .btn{
           display: inline-block;
            font-size:14px;
            font-weight:500;
            line-height:36px;
            width:100px;
            height:36px;
            border-radius:2px;
            text-align: center;
            border: 1px solid #2c7cff;
            color: #2c7cff;
            cursor: pointer;
            &:hover{
              color: #fff;
              background: rgba(44, 124, 255,0.5);
              border: 1px solid rgba(44, 124, 255,0.5);
            }
        }
      }
}
.news2{
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 60px;
  .el-carousel__item{
    padding: 0 100px;
  }
  .el-carousel__indicators--outside button{
        background-color: #007dff;
  }
  .el-carousel__indicator--horizontal{
    padding-top:20px;
    padding-bottom: 0;
  }
  .content_box{
    float: left;
    width: 520px;
    height: 300px;
    padding-left: 40px;
    padding-right: 20px;
    box-sizing: border-box;
    background: #FFFFFF;
    .name {
        width: 410px;
        font-size: 20px;
        font-weight: 600;
        padding: 40px 0 30px;
    }
    .desc {
      width: 410px;
      line-height: 25px;
      font-size: 14px;
      margin-bottom: 30px;
      height: 75px;
      overflow: hidden;
    }
    .detail {
      display: block;
      width: 100px;
      color: #007dff;
      height: 32px;
      line-height: 30px;
      font-size: 12px;
      text-align: center;
      border: 1px solid #007dff;
      cursor: pointer;
    }
  }
  .img_box{
    float: left;
    width: 480px;
    height: 300px;
    margin: 0 auto;
    overflow: hidden;
    transform: scale(1);
    transition: all 0.4s ease-in-out;
    img{
          width: 480px;
          // height: 420px;
    }
    &:hover{
      transform: scale(1.05);
      transition: all 0.4s ease-in-out;
    }
  }
}
</style>
